import * as React from 'react';
import { observer } from 'mobx-react';
import ParticipantsStore from '../../../../../../../ParticipantsStore';
import UserGroupMembershipsStore from '../Store';
import AddUserGroupMembershipsReactions from '../Store/Reactions';
import FormState from './FormState';
import ModalStore from '../../../../../../Modal/Store';

interface Props {
  store: ParticipantsStore;
  modalStore: ModalStore;
}

class AddUserGroupMembershipsForm extends React.Component<Props, {}> {
  private userGroupMembershipsStore: UserGroupMembershipsStore = new UserGroupMembershipsStore(
    this.props.store,
  );

  render() {
    return (
      <>
        <FormState
          participantsStore={this.props.store}
          userGroupMembershipsStore={this.userGroupMembershipsStore}
          modalStore={this.props.modalStore}
        />
        <AddUserGroupMembershipsReactions
          store={this.userGroupMembershipsStore}
          fireImmediately={true}
        />
      </>
    );
  }
}

export default observer(AddUserGroupMembershipsForm);
